import React from 'react'
import PropTypes from 'prop-types'
import Icon from '../Icon/Icon'
import './_links.scss'

export const ExternalLink = ({ data, icon, scroll }) => {
  switch (data.type) {
    case 'link':
      return (
        <a
          href={data.url}
          className={`d-flex flex-row text-uppercase nav-link link-style ${
            scroll < 577 ? 'link-style-white' : 'link-style-dark'
          }`}
          target='_blank'
          rel='noreferrer'
        >
          {icon && <Icon {...icon} hasMargin={true}/>}
          {data.name}
        </a>
      )
    case 'button':
      return (
        <a
          href={data.url}
          className={`btn btn-md rounded-pill d-flex flex-row px-3 text-uppercase btn-style`}
          target='_blank'
          rel='noreferrer'
        >
          {icon && <Icon {...icon} hasMargin={true}/>}
          {data.name}
        </a>
      )
    case 'buttonWhite':
      return (
        <a
          href={data.url}
          className={`btn btn-md rounded-pill d-flex flex-row px-3 text-uppercase btn-white-style ${
            scroll < 577 ? 'btn-white-style-white' : 'btn-white-style-dark'
          }`}
          target='_blank'
          rel='noreferrer'
        >
          {icon && <Icon {...icon} hasMargin={true}/>}
          {data.name}
        </a>
      )

    default:
      return (
        <a
          href={data.url}
          className={`d-flex flex-row text-uppercase nav-link link-style ${
            scroll < 577 ? 'link-style-white' : 'link-style-dark'
          }`}
          target='_blank'
          rel='noreferrer'
        >
          {icon && <Icon {...icon} hasMargin={true}/>}
          {data.name}
        </a>
      )
  }
}

ExternalLink.propTypes = {
  icon: PropTypes.object,
  data: PropTypes.object.isRequired
}
